
import eventBus from '@/plugins/eventBus'
import CartItem from '@/components/CartItem.vue'
import { Component, Vue } from 'vue-property-decorator'
import { CartModel } from '@/store/models/CartModel'
import { ItemModel } from '@/store/models/ItemModel'
import { UserModel } from '@/store/models/UserModel'
import SButton from '@/components/SButton.vue'
import api from '@/plugins/api'
import { generalError, emptyCart } from '@/plugins/popups'
import { envConfiguration } from '@/plugins/globalStaticDatas'

@Component({
  components: {
    CartItem,
    SButton,
  },
})
export default class Cart extends Vue {
  cart: CartModel = CartModel.getInstance()
  user: UserModel = UserModel.getInstance()
  showCart: boolean = false
  checkoutDetails: any[] | undefined
  disableCheckoutBtn: boolean = false
  envConfigurations: object = envConfiguration

  toggleCart() {
    this.showCart = !this.showCart
  }
  hideCart() {
    if (this.showCart) {
      this.showCart = !this.showCart
    }
  }

  viewCheckoutModal(product: any, total: any) {
    this.disableCheckoutBtn = true
    if (this.cart.count === 0) {
      emptyCart()
      this.disableCheckoutBtn = false
      return
    }
    if (this.user.isLogged()) {
      api()
        .post(`/me/checkout-info`, {
          products: this.cart.getItems(),
        })
        .then((response) => {
          this.disableCheckoutBtn = true
          this.checkoutDetails = response.data.data
          eventBus.$emit('checkout-modal', product, total, this.checkoutDetails)
          this.toggleCart()
          this.disableCheckoutBtn = false
        })
        .catch((error) => {
          generalError()
          this.disableCheckoutBtn = false
        })
      return
    }
    this.disableCheckoutBtn = true
    api()
      .post(`/checkout-info`, {
        products: this.cart.getItems(),
      })
      .then((response) => {
        this.disableCheckoutBtn = true
        this.checkoutDetails = response.data.data
        if (this.checkoutDetails) {
          eventBus.$emit('checkout-modal', product, total, this.checkoutDetails)
          this.toggleCart()
          this.disableCheckoutBtn = false
        }
      })
      .catch((error) => {
        generalError()
        this.disableCheckoutBtn = false
      })
  }

  mounted() {
    eventBus.$on('remove-cart-items', () => {
      this.cart.items = []
      this.cart.total = 0
      this.cart.count = 0
    })

    eventBus.$on('cart:item-added', (product: ItemModel) => {
      this.cart.addItems(product)
    })

    eventBus.$on('cart:from-modal', (product: ItemModel) => {
      this.cart.addItems(product)
    })

    eventBus.$on('cart-item:updated-quantity', (item: any) => {
      this.cart.updateQuantity(item)
    })
    this.cart.localFetch()
  }
}
